import { $$ } from "../utils/dom";

const isMultiple = $$('#blog-featured-posts .swiper-slide').length > 1

const blogFeaturedCarousel = new Swiper('#blog-featured-posts', {
    loop: isMultiple,
    autoplay: isMultiple,
})